import { Modal, Upload, message } from 'antd';
import { useState } from 'react';

const UploadPhoto = ({ onClose, onSave }) => {
  const [file, setFile] = useState(null);

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('Можно загружать только изображения');
      return Upload.LIST_IGNORE;
    }
    setFile(file);
    return false;
  };

  const onSaveBtn = (event) => {
    event.preventDefault();
    if (!file) {
      message.warning('Выберите изображение перед сохранением');
      return;
    }
    onSave(file);
    onClose(true);
  };

  const formStyles = {
    content: { padding: 8 },
    footer: { marginTop: 0 },
  };

  return (
    <Modal width={400} open closeIcon={null} onCancel={() => onClose()} onOk={onSaveBtn} styles={formStyles} okButtonProps={{ disabled: !file }}>
      <Upload.Dragger name="file" beforeUpload={beforeUpload} accept="image/*" multiple={false} showUploadList={false} style={{ padding: 20, marginBottom: 8 }}>
        <p style={{ margin: 0 }}>Кликните или перетащите изображение для загрузки</p>
        <p style={{ margin: 0 }}>Макс размер файла не более 2 Мб</p>
      </Upload.Dragger>

      {file && (
        <div style={{ marginTop: 8, marginBottom: 8, textAlign: 'center' }}>
          <img
            src={URL.createObjectURL(file)}
            alt="preview"
            style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'contain' }}
          />
        </div>
      )}
    </Modal>
  );
};

export default UploadPhoto;
